import { DELETE } from "../../APiHelper/API"

export const deleteLeague = (leagueId, onSuccess, onError) => {
    DELETE(`/api/v1/leagues/${leagueId}`, onSuccess, onError)
}